/* eslint-disable */
import React, {useState} from 'react';
import 'contents/assets/scss/page/mypage.scss';
function AccessSetting() {
  const depth1 = ['학생관리', '교사관리', '교재관리', '자료실', '커뮤니티', '교사교육', '홍보', '회계관리', '업무관리', '통계'];
  const depth2 = ['과목별', '준비중 교사', '교사 배정지도'];
  const [selectedItems, setSelectedItems] = useState(Array(depth2.length).fill(false));
  const handleCheckboxChange = (index) => {
    const updatedSelectedItems = [...selectedItems];
    updatedSelectedItems[index] = !updatedSelectedItems[index];
    setSelectedItems(updatedSelectedItems);
  };

  return (
    <main className="com_container p_access_setting">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu9_13">페이지 접근 설정</h2>
          <div className="info_txt com_red_txt">* 선택이 안된 페이지 및 회원은 마이페이지 이외에 모든 페이지가 비노출 처리 됩니다.</div>
        </section>
        <section className="com_pg_container">
          <section className="box full">
            <div className="scroll_wrap">
              <div className="cont_scroll">
                {/* 뷰 페이지 */}
                <table className="com_board_list setting_table">
                  <colgroup>
                    <col width="240" />
                    <col width="320" />
                    <col width="320" />
                    <col width="320" />
                    <col width="320" />
                    <col width="320" />
                    <col width="320" />
                    <col width="320" />
                  </colgroup>
                  <tbody>
                    <tr>
                      <th>
                        뷰 페이지
                        <div className="sub"> (볼 수만 있는 페이지)</div>
                      </th>
                      <td>
                        <div className="menu_wrap">
                          <button className="btn_minus_gray"></button>
                          <ul className="menu_list">
                            <li className="depth1">
                              <div className="depth_row">
                                <div className="check">
                                  <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                                  <label htmlFor="chk01">학생관리</label>
                                </div>
                                <button className="arrow up"></button>
                              </div>
                            </li>
                            <li className="depth1">
                              <div className="depth_row">
                                <div className="check">
                                  <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                                  <label htmlFor="chk01">교사관리</label>
                                </div>
                                <button className="arrow up"></button>
                              </div>
                            </li>
                            <li className="depth1">
                              <div className="depth_row">
                                <div className="check">
                                  <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                                  <label htmlFor="chk01">교재관리</label>
                                </div>
                                <button className="arrow up"></button>
                              </div>
                            </li>
                            <li className="depth1">
                              <div className="depth_row">
                                <div className="check">
                                  <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                                  <label htmlFor="chk01">자료실</label>
                                </div>
                                <button className="arrow up"></button>
                              </div>
                            </li>
                            <li className="depth1">
                              <div className="depth_row">
                                <div className="check">
                                  <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                                  <label htmlFor="chk01">커뮤니티</label>
                                </div>
                                <button className="arrow up"></button>
                              </div>
                            </li>
                            <li className="depth1">
                              <div className="depth_row">
                                <div className="check">
                                  <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                                  <label htmlFor="chk01">교사교육</label>
                                </div>
                                <button className="arrow up"></button>
                              </div>
                            </li>
                            <li className="depth1">
                              <div className="depth_row">
                                <div className="check">
                                  <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                                  <label htmlFor="chk01">홍보</label>
                                </div>
                                <button className="arrow up"></button>
                              </div>
                            </li>
                            <li className="depth1">
                              <div className="depth_row">
                                <div className="check">
                                  <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                                  <label htmlFor="chk01">회계관리</label>
                                </div>
                                <button className="arrow up"></button>
                              </div>
                            </li>
                            <li className="depth1">
                              <div className="depth_row">
                                <div className="check">
                                  <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                                  <label htmlFor="chk01">업무관리</label>
                                </div>
                                <button className="arrow up"></button>
                              </div>
                            </li>
                            <li className="depth1">
                              <div className="depth_row">
                                <div className="check">
                                  <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                                  <label htmlFor="chk01">통계</label>
                                </div>
                                <button className="arrow up"></button>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </td>
                      <td>
                        <div className="menu_wrap">
                          <button className="btn_minus_gray"></button>
                          <ul className="menu_list">
                            <li className="depth1">
                              <div className="depth_row">
                                <div className="check">
                                  <input type="checkbox" name="chk" id="" className="com_chk" />
                                  <label htmlFor="">학생관리</label>
                                </div>
                                <button className="arrow up"></button>
                              </div>
                            </li>
                            <li className="depth1">
                              <div className="depth_row">
                                <div className="check">
                                  <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                                  <label htmlFor="chk01">교사관리</label>
                                </div>
                                <button className="arrow down"></button>
                              </div>
                              <ul className="menu_list">
                                <li className="depth2 selected">
                                  <div className="depth_row">
                                    <div className="check">
                                      <input type="checkbox" name="chk" id="chkSelect" className="com_chk" />
                                      <label htmlFor="chkSelect">교사목록</label>
                                    </div>
                                  </div>
                                </li>
                                {depth2.map((depth2Item, subI) => (
                                  <li key={subI} className={`depth2 ${selectedItems[subI] ? 'selected' : ''}`}>
                                    <div className="depth_row">
                                      <div className="check">
                                        <input type="checkbox" name="chk" id={`chk01${subI}`} className="com_chk" checked={selectedItems[subI]} onChange={() => handleCheckboxChange(subI)} />
                                        <label htmlFor={`chk01${subI}`}>{depth2Item}</label>
                                      </div>
                                    </div>
                                  </li>
                                ))}
                                <li className="depth1">
                                  <div className="depth_row">
                                    <div className="check">
                                      <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                                      <label htmlFor="chk01">홍보</label>
                                    </div>
                                    <button className="arrow up"></button>
                                  </div>
                                </li>
                                <li className="depth1">
                                  <div className="depth_row">
                                    <div className="check">
                                      <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                                      <label htmlFor="chk01">회계관리</label>
                                    </div>
                                    <button className="arrow up"></button>
                                  </div>
                                </li>
                                <li className="depth1">
                                  <div className="depth_row">
                                    <div className="check">
                                      <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                                      <label htmlFor="chk01">업무관리</label>
                                    </div>
                                    <button className="arrow up"></button>
                                  </div>
                                </li>
                              </ul>
                            </li>
                          </ul>
                        </div>
                      </td>
                      <td>
                        <div className="menu_wrap">
                          <button className="btn_minus_gray"></button>
                          <ul className="menu_list">
                            <li className="depth1">
                              <div className="depth_row">
                                <div className="check">
                                  <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                                  <label htmlFor="chk01">학생관리</label>
                                </div>
                                <button className="arrow up"></button>
                              </div>
                            </li>
                            <li className="depth1">
                              <div className="depth_row">
                                <div className="check">
                                  <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                                  <label htmlFor="chk01">교사관리</label>
                                </div>
                                <button className="arrow up"></button>
                              </div>
                            </li>
                            <li className="depth1">
                              <div className="depth_row">
                                <div className="check">
                                  <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                                  <label htmlFor="chk01">교재관리</label>
                                </div>
                                <button className="arrow up"></button>
                              </div>
                            </li>
                            <li className="depth1">
                              <div className="depth_row">
                                <div className="check">
                                  <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                                  <label htmlFor="chk01">자료실</label>
                                </div>
                                <button className="arrow up"></button>
                              </div>
                            </li>
                            <li className="depth1">
                              <div className="depth_row">
                                <div className="check">
                                  <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                                  <label htmlFor="chk01">커뮤니티</label>
                                </div>
                                <button className="arrow up"></button>
                              </div>
                            </li>
                            <li className="depth1">
                              <div className="depth_row">
                                <div className="check">
                                  <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                                  <label htmlFor="chk01">교사교육</label>
                                </div>
                                <button className="arrow up"></button>
                              </div>
                            </li>
                            <li className="depth1">
                              <div className="depth_row">
                                <div className="check">
                                  <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                                  <label htmlFor="chk01">홍보</label>
                                </div>
                                <button className="arrow up"></button>
                              </div>
                            </li>
                            <li className="depth1">
                              <div className="depth_row">
                                <div className="check">
                                  <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                                  <label htmlFor="chk01">회계관리</label>
                                </div>
                                <button className="arrow up"></button>
                              </div>
                            </li>
                            <li className="depth1">
                              <div className="depth_row">
                                <div className="check">
                                  <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                                  <label htmlFor="chk01">업무관리</label>
                                </div>
                                <button className="arrow up"></button>
                              </div>
                            </li>
                            <li className="depth1">
                              <div className="depth_row">
                                <div className="check">
                                  <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                                  <label htmlFor="chk01">통계</label>
                                </div>
                                <button className="arrow up"></button>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
                {/* 댓긆 */}
                <table className="com_board_list setting_table">
                  <colgroup>
                    <col width="240" />
                    <col width="320" />
                    <col width="320" />
                    <col width="320" />
                    <col width="320" />
                    <col width="320" />
                    <col width="320" />
                    <col width="320" />
                  </colgroup>
                  <tbody>
                    <tr>
                      <th>
                        댓글 가능 페이지
                        <div className="sub">
                          (문서, 댓글 등록 및<br />
                          파일 다운로드 가능)
                        </div>
                      </th>
                      <td></td>
                      <td>
                        <div className="menu_wrap">
                          <button className="btn_minus_gray"></button>
                          <ul className="menu_list">
                            <li className="depth1">
                              <div className="depth_row">
                                <div className="check">
                                  <input type="checkbox" name="chk" id="" className="com_chk" />
                                  <label htmlFor="">학생관리</label>
                                </div>
                                <button className="arrow up"></button>
                              </div>
                            </li>
                            <li className="depth1">
                              <div className="depth_row">
                                <div className="check">
                                  <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                                  <label htmlFor="chk01">교사관리</label>
                                </div>
                                <button className="arrow down"></button>
                              </div>
                              <ul className="menu_list">
                                <li className="depth2 selected">
                                  <div className="depth_row">
                                    <div className="check">
                                      <input type="checkbox" name="chk" id="chkSelect" className="com_chk" />
                                      <label htmlFor="chkSelect">교사목록</label>
                                    </div>
                                  </div>
                                </li>
                                {depth2.map((depth2Item, subI) => (
                                  <li key={subI} className={`depth2 ${selectedItems[subI] ? 'selected' : ''}`}>
                                    <div className="depth_row">
                                      <div className="check">
                                        <input type="checkbox" name="chk" id={`chk01${subI}`} className="com_chk" checked={selectedItems[subI]} onChange={() => handleCheckboxChange(subI)} />
                                        <label htmlFor={`chk01${subI}`}>{depth2Item}</label>
                                      </div>
                                    </div>
                                  </li>
                                ))}
                                <li className="depth1">
                                  <div className="depth_row">
                                    <div className="check">
                                      <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                                      <label htmlFor="chk01">홍보</label>
                                    </div>
                                    <button className="arrow up"></button>
                                  </div>
                                </li>
                                <li className="depth1">
                                  <div className="depth_row">
                                    <div className="check">
                                      <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                                      <label htmlFor="chk01">회계관리</label>
                                    </div>
                                    <button className="arrow up"></button>
                                  </div>
                                </li>
                                <li className="depth1">
                                  <div className="depth_row">
                                    <div className="check">
                                      <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                                      <label htmlFor="chk01">업무관리</label>
                                    </div>
                                    <button className="arrow up"></button>
                                  </div>
                                </li>
                              </ul>
                            </li>
                          </ul>
                        </div>
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
                {/* 승인 기능 */}
                <table className="com_board_list setting_table">
                  <colgroup>
                    <col width="240" />
                    <col width="320" />
                    <col width="320" />
                    <col width="320" />
                    <col width="320" />
                    <col width="320" />
                    <col width="320" />
                    <col width="320" />
                  </colgroup>
                  <tbody>
                    <tr>
                      <th>
                        승인 가능 페이지
                        <div className="sub">(승인 및 결제 가능)</div>
                      </th>
                      <td></td>
                      <td>
                        <div className="menu_wrap">
                          <button className="btn_minus_gray"></button>
                          <ul className="menu_list">
                            <li className="depth1">
                              <div className="depth_row">
                                <div className="check">
                                  <input type="checkbox" name="chk" id="" className="com_chk" />
                                  <label htmlFor="">학생관리</label>
                                </div>
                                <button className="arrow up"></button>
                              </div>
                            </li>
                            <li className="depth1">
                              <div className="depth_row">
                                <div className="check">
                                  <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                                  <label htmlFor="chk01">교사관리</label>
                                </div>
                                <button className="arrow down"></button>
                              </div>
                              <ul className="menu_list">
                                <li className="depth2 selected">
                                  <div className="depth_row">
                                    <div className="check">
                                      <input type="checkbox" name="chk" id="chkSelect" className="com_chk" />
                                      <label htmlFor="chkSelect">교사목록</label>
                                    </div>
                                  </div>
                                </li>
                                {depth2.map((depth2Item, subI) => (
                                  <li key={subI} className={`depth2 ${selectedItems[subI] ? 'selected' : ''}`}>
                                    <div className="depth_row">
                                      <div className="check">
                                        <input type="checkbox" name="chk" id={`chk01${subI}`} className="com_chk" checked={selectedItems[subI]} onChange={() => handleCheckboxChange(subI)} />
                                        <label htmlFor={`chk01${subI}`}>{depth2Item}</label>
                                      </div>
                                    </div>
                                  </li>
                                ))}
                                <li className="depth1">
                                  <div className="depth_row">
                                    <div className="check">
                                      <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                                      <label htmlFor="chk01">홍보</label>
                                    </div>
                                    <button className="arrow up"></button>
                                  </div>
                                </li>
                                <li className="depth1">
                                  <div className="depth_row">
                                    <div className="check">
                                      <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                                      <label htmlFor="chk01">회계관리</label>
                                    </div>
                                    <button className="arrow up"></button>
                                  </div>
                                </li>
                                <li className="depth1">
                                  <div className="depth_row">
                                    <div className="check">
                                      <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                                      <label htmlFor="chk01">업무관리</label>
                                    </div>
                                    <button className="arrow up"></button>
                                  </div>
                                </li>
                              </ul>
                            </li>
                          </ul>
                        </div>
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
                <div className="detail_tit dot">접근 해당 선택</div>
                {/* 뷰 페이지 */}
                <table className="com_board_list setting_table">
                  <colgroup>
                    <col width="240" />
                    <col width="320" />
                    <col width="320" />
                    <col width="320" />
                    <col width="320" />
                    <col width="320" />
                    <col width="320" />
                    <col width="320" />
                  </colgroup>
                  <tbody>
                    <tr>
                      <th>
                        <div className="check">
                          <button className="btn_minus"></button>
                          <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
                          <label htmlFor="rdo01">부서</label>
                          <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                          <label htmlFor="rdo02">직급</label>
                        </div>
                      </th>
                      <td>
                        <ul className="com_input_sec">
                          <li>
                            <select name="" id="">
                              <option value="">전략기획실</option>
                            </select>
                          </li>
                          <li>
                            <select name="" id="">
                              <option value="">전략기획실</option>
                            </select>
                          </li>
                          <li>
                            <select name="" id="">
                              <option value="">전략기획실</option>
                            </select>
                          </li>
                        </ul>
                      </td>
                      <td>
                        <ul className="com_input_sec">
                          <li>
                            <select name="" id="">
                              <option value="">없음</option>
                            </select>
                          </li>
                        </ul>
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>

                <table className="com_board_list setting_table">
                  <colgroup>
                    <col width="240" />
                    <col width="320" />
                    <col width="320" />
                    <col width="320" />
                    <col width="320" />
                    <col width="320" />
                    <col width="320" />
                    <col width="320" />
                  </colgroup>
                  <tbody>
                    <tr>
                      <th>
                        <div className="check">
                          <button className="btn_minus"></button>
                          <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
                          <label htmlFor="rdo01">부서</label>
                          <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                          <label htmlFor="rdo02">직급</label>
                        </div>
                      </th>
                      <td>
                        <ul className="com_input_sec">
                          <li>
                            <select name="" id="">
                              <option value="">부장</option>
                            </select>
                          </li>
                        </ul>
                      </td>
                      <td>
                        <ul className="com_input_sec">
                          <li>
                            <select name="" id="">
                              <option value="">교사</option>
                            </select>
                          </li>
                        </ul>
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <button className="btn_add_setting">
                <div className="txt">
                  <span>+</span>추가
                </div>
              </button>
            </div>
            <div className="com_btn_wrap bottom">
              <button className="com_btn black xs">
                <span className="com_point_txt">+</span>추가
              </button>
            </div>
            <hr className="com_divider" />

            <div className="com_btn_wrap bottom center">
              <button className="com_btn orange xs">수정</button>
            </div>
          </section>
        </section>
      </div>
    </main>
  );
}

export default AccessSetting;
